import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import SEOContentSection from "./components/SEOContentSection";
import TestimonialSection from "./components/TestimonialSection";
import BrandSection from "./components/BrandSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <SEOContentSection />
        <TestimonialSection />
        <BrandSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}